import { FC, ReactNode } from 'react'
import { GuestAvatar, GuestAvatarType } from './GuestAvatar'
import { StatusManager, StatusManagerType } from './StatusManager'
import { ParticipationForm, ParticipationFormType } from './form/Form'

const EventParticipation: FC &
  GuestAvatarType &
  StatusManagerType &
  ParticipationFormType = (): ReactNode => <></>

EventParticipation.GuestAvatar = GuestAvatar
EventParticipation.StatusManager = StatusManager
EventParticipation.Form = ParticipationForm

export default EventParticipation
